module.exports = __webpack_public_path__ + "img/huaian.10ad09b.png";